import "./style.css";
import Hero from "./components/Hero";
import NetworkIntro from "./components/NetworkIntro";
import EcosystemFoundation from "./components/EcosystemFoundation";
import HowItWorks from "./components/HowItWorks";
import CareerMatrix from "./components/CareerMatrix";
import AuditBenchmarks from "./components/AuditBenchmarks";
import ValueSchedule from "./components/ValueSchedule";
import Incentives from "./components/Incentives";
import Credentials from "./components/Credentials";
import LeadershipCadre from "./components/LeadershipCadre";
import ComplianceDefense from "./components/ComplianceDefense";
import DashboardPreview from "./components/DashboardPreview";
import Faq from "./components/Faq";
import CtaFooter from "./components/CtaFooter";
import Navbar from "../../../components/Landing_page_Navbar/index"
export default function MarketingAgentPage() {
  return (
    <>
      <Navbar />
      <Hero />
      <NetworkIntro />
      <EcosystemFoundation />
      <HowItWorks />
      <CareerMatrix />
      <AuditBenchmarks />
      <ValueSchedule />
      <Incentives />
      <Credentials />
      <LeadershipCadre />
      <ComplianceDefense />
      <DashboardPreview />
      <Faq />
      <CtaFooter />
    </>
  );
}
